export interface ReferenceInfo {
    id: number;
    uid: string;
    group_uid: string;
    short_name: string;
    full_name: string;
}

export interface ReferenceInfoExt extends ReferenceInfo {
    help?: string;
}

